export const LOAD_QUOTE = 'LOAD_QUOTE';
export const ADD_NEW_QUOTE = 'ADD_NEW_QUOTE';
export const ADD_NEW_QUOTE_ITEM = 'ADD_NEW_QUOTE_ITEM';
export const EDIT_QUOTE_ITEM = 'EDIT_QUOTE_ITEM';
export const CANCEL_QUOTE = 'CANCEL_QUOTE';
export const CLONE_QUOTE = 'CLONE_QUOTE';
export const LOAD_BILLING_OF_QUOTE = 'LOAD_BILLING_OF_QUOTE';
export const CHANGE_QUOTE_STATUS = 'CHANGE_QUOTE_STATUS';
export const EDIT_QUOTE = 'EDIT_QUOTE';
export const LOAD_QUOTES_CONTACT = 'LOAD_QUOTES_CONTACT';
export const LOAD_QUOTES_SENDER = 'LOAD_QUOTES_SENDER';
export const ADD_NEW_FAVORIS_QUOTE = 'ADD_NEW_FAVORIS_QUOTE';
export const DELETE_FAVORIS_QUOTE = 'DELETE_FAVORIS_QUOTE';
export const CLONE_QUOTE_ITEM = 'CLONE_QUOTE_ITEM';
export const DELETE_QUOTE_ITEM = 'DELETE_QUOTE_ITEM';
export const ADD_QUOTE_ADDITIONAL_ITEM = 'ADD_QUOTE_ADDITIONAL_ITEM';
export const DELETE_QUOTE_ADDITIONAL_ITEM = 'DELETE_QUOTE_ADDITIONAL_ITEM';
export const SET_QUOTE_NEEDED_DATA = 'SET_QUOTE_NEEDED_DATA';
export const DOWNLOAD_QUOTE_PDF = 'DOWNLOAD_QUOTE_PDF';
